export default {
    TEXT: "text",
    PARTNUMBER: "part number",
    SYMBOL: "symbol",
    FOOTPRINT: "footprint",
    PSPICEMODEL: "pspice model",
    ROHS: "rohs",
    VALUE: "value",
    TYPE: "type",
    DESCRIPTION: "description",
    HDLSYMBOL: "hdl symbol",
    PACKTYPE: "pack type",
    PARTTYPE: "part type",
    LIBRARY: "library",
    ALTSYMBOLS: "alt symbols",
    LINK: "link",
    KICADSYMBOL: "kicad symbol",
    KICADFOOTPRINT: "kicad footprint",
}



// WEBPACK FOOTER //
// ./src/constants/PartPropertiesType.js